<template>
  <!-- 二维码弹框（业务类型的组件） -->
  <el-form :model="form" ref="form" :rules="rules" @submit.native.prevent>
    <el-dialog
      class="safe-dialog"
      title="安全认证"
      :append-to-body="false"
      :modal-append-to-body="false"
      width="336px"
      :visible="visible"
      @close="onCloseSelf()"
      @closed="onResetValue()"
    >
      <el-form-item prop="captcha_code" :error="error">
        <div class="code-input">
          <el-input v-model="form.captcha_code" autofocus />
          <ImgCaptcha class="code"
                      :loading.sync="loadingCaptcha"
                      :src="imageCodeURL"
                      alt="验证码"
                      @click.native="onRefreshImageCode">
          </ImgCaptcha>
        </div>
      </el-form-item>

      <div class="dialog-btns">
        <zt-button @click="onCloseSelf()" class="mr8">取消</zt-button>
        <zt-button
          type="primary"
          @click.enter.exact="onConfirm"
          :loading="loading"
          native-type="submit"
        >确定</zt-button>
      </div>
    </el-dialog>
  </el-form>
</template>

<script>
import createUniqueString from "@/utils/createUniqueString";
import ImgCaptcha from '@/components/ImgCaptcha'


import {
  captcha,
  login_sms_code,
  forget_sms_code,
  reg_sms_code
} from "@/api/login";

export default {
  name: "ImageCodeDialog",
  components: { ImgCaptcha },
  props: {
    telephone: String, // 需要发送短信的手机号码
    visible: Boolean, // 是否弹出dialog
    isForget: Boolean, // 是否是忘记密码
    apiType: {
      type: String,
      default: "login" // login, forget, reg
    }
  },
  computed: {
    imageCodeURL() {
      return captcha(this.captcha_r, this.captcha_t);
    }
  },
  data: () => ({
    form: {
      captcha_code: ""
    },
    rules: {
      captcha_code: [{ required: true, message: "请输入验证码" }]
    },

    // 图形验证码
    captcha_r: createUniqueString(), // 图形验证码的r
    captcha_t: Date.now(), // 图形验证码的时间戳（避免304缓存）
    loadingCaptcha: false,

    loading: false,
    error: ""
  }),

  methods: {
    // 刷新验证码
    onRefreshImageCode() {
      if(this.loadingCaptcha) return
      this.captcha_t = createUniqueString();
    },

    // 确定按钮
    onConfirm() {
      const { form } = this.$refs;
      form.clearValidate();

      form.validate(valid => {
        if (!valid) return;

        this.loading = true;

        const name =
          this.apiType == "forget"
            ? forget_sms_code
            : this.apiType == "reg"
              ? reg_sms_code
              : login_sms_code;

        // 如果是忘记密码，则调用忘记密码的api
        this.sendSms(name);
      });
    },

    sendSms(apiFunction) {
      const data = {
        ...this.form,
        captcha_r: this.captcha_r,
        telephone: this.telephone
      };
      apiFunction(data)
        .then(({ data }) => {
          const { error_code, error_message } = data;
          if (error_code != 0) {
            this.setErr("error", error_message);
            // this.onRefreshImageCode()
          } else {
            // 验证码已发送
            this.onCloseSelf();
            this.$message({
              type: "success",
              message: "验证码已发送"
            });

            this.$emit("success");
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.$message({
            type: "error",
            message: "未知错误，请刷新页面重试"
          });
        });
    },

    // 关闭自己
    onCloseSelf() {
      this.$emit("update:visible", false);
    },

    // 初始化所有数据
    onResetValue() {
      this.$refs.form.resetFields();
      this.onRefreshImageCode();
    },

    // 设置err，修复重复错误无法重复提示
    setErr(name, error_message) {
      this[name] = " ";
      this.$nextTick(() => {
        this[name] = error_message;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/login.scss";

.el-dialog__wrapper {
  /deep/ .el-dialog__body {
    padding: 26px 16px 18px;

    .dialog-btns {
      text-align: right;
      margin-top: 44px;
    }
    .zt-button {
      width: auto;
    }
  }
}

.mr8 {
  margin-right: 8px;
}
</style>
